/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Help_Users_ManagementInputs */



/**
* | output |
* | --- |
* | "User management" |
*
* @param {Users_Help_Users_ManagementInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const users_help_users_management = /** @type {((inputs?: Users_Help_Users_ManagementInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Help_Users_ManagementInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("User management")
	return /** @type {LocalizedString} */ ("Gestion des utilisateurs")
});